var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-column",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%","overflow":"hidden"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }